import {PerformanceLogger} from '../performance';
import {LOG_TYPE} from './const';
import {getProfileData, reloadAndProfile, stopProfiling} from './reactDevTools';

export const PROFILER_KEY = {
    app: 'App',
    entry: 'Entry',
    knowledge: 'Knowledge',
    sideBar: 'SideBar',
    docHome: 'DocHome',
    document: 'Document',
    editor: 'Editor',
    realtimeEditor: 'RealtimeEditor',
};

const getInitProfileData = () => {
    const res = {};
    Object.keys(PROFILER_KEY).forEach(key => {
        // @ts-ignore
        res[PROFILER_KEY[key]] = {
            renderCount: 0,
            renderTime: 0,
        };
    });
    return res;
};

const isProfiling = process.env.isProfiling;

export class CompRender {

    key = 'CompRender';

    logger: PerformanceLogger;

    profileData: any;

    snapshot: any;

    constructor(logger: PerformanceLogger) {
        this.logger = logger;
        this.profileData = getInitProfileData();
        this.snapshot = null;
    }

    reload = () => {
        reloadAndProfile();
    };

    onRender = (
        id: any, phase: any, actualDuration: any, baseDuration: any, startTime: any, commitTime: any
    ) => {
        const profileData = this.profileData;
        profileData[id].renderCount++;
        profileData[id].renderTime += actualDuration;
    };

    getProfileData = () => {
        return Object.keys(this.profileData).map((key) => {
            const {
                renderCount,
                renderTime,
            } = this.profileData[key];
            return {
                component: key,
                count: renderCount,
                duration: renderTime,
            };
        });
    };

    getDevToolsData = () => {
        return getProfileData();
    };

    takeSnapshot = () => {
        if (isProfiling) {
            stopProfiling();
            this.snapshot = {
                fromProfile: this.getProfileData(),
                fromDevtools: this.getDevToolsData(),
            };
        }
    };

    getData() {
        return {
            type: this.key,
            logType: LOG_TYPE.period,
            origin: this.snapshot,
        };
    }
}
